/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useCallback } from 'react';
import { useFormik } from 'formik';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import CardConfig from 'components/CardConfig';
import {
  AToFGrade,
  gradingOptionKeys,
  gradingScaleOptions,
  normalizeCourseGradesToStrings,
  scheduleOptions,
  schoolYearOptions,
  to100Grade,
  to4Grade,
} from './courseConstant';
import { getCollegeData, updateHighSchoolFromCourse } from 'app/highSchoolSlice/highSchoolSlice';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import SubjectConfig from './SubjectConfig';
import { FormCourse, SubjectDetail, subjectDetailModal } from 'modal/course';
import {
  checkEnableParseJSON,
  optionStringValues,
  removeDuplicate,
  reorder,
} from 'components/helper/helper';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Button } from 'react-bootstrap';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { ExpandMore as ActivitiesExpandMore } from 'screen/activitiesAndHonors/Activities';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import { Chip } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/joy/Grid';
import { fixCourseConfigValues } from 'screen/common/helper/fixValuesOnLoad';
import { ModalConfirm } from 'screen/common/ModalConfirm';
import { debounce } from 'lodash';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

export const fixCourseSubjectDetail = (course: any) => {
  let arr: any[] = course.subjectDetails.filter((i: any) => i !== null && i !== undefined);
  course.subjectDetails = [...arr];
  return course;
};

export function ordinal_suffix_of(n: number) {
  let i = n + 1;
  let j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + 'st';
  }
  if (j === 2 && k !== 12) {
    return i + 'nd';
  }
  if (j === 3 && k !== 13) {
    return i + 'rd';
  }
  return i + 'th';
}

const buildYears = (selectedSchool: any) => {
  if (selectedSchool?.other?.academic_year) {
    return selectedSchool?.other?.academic_year;
  } else {
    return [
      selectedSchool?.other?.st_academic_year,
      selectedSchool?.other?.nd_academic_year,
      selectedSchool?.other?.rd_academic_year,
      selectedSchool?.other?.th_academic_year,
    ].filter((i) => !!i && i !== '-- select --' && i !== '- Select -');
  }
};

interface Props {
  is12?: boolean;
  defaultGradeValue?: string;
  handleSave: (value: any) => void;
  item: any;
  index: number;
  total: number;
  expandAll?: boolean;
  handleExpandActive: (value: any) => void;
  handleRemove?: () => void;
  onExpandChange?: (index: number, expanded: boolean) => void;
  isMobile?: boolean;
  disabled?: boolean;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const StyledExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const CourseConfig = (props: Props) => {
  const { isMobile = false } = props;
  const MAX_SUBJECTS = 15;
  const [addSubject, setAddSubject] = React.useState(false);
  const highSchoolData = useAppSelector((store) => store.highSchool.highSchoolData);
  const myHighSchool = useAppSelector((store) => store.highSchool.myHighSchool);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const check = query.get('check');
  const initialValues: FormCourse = {
    index: Number(props.item?.index ?? -1),
    lastIndex: null,
    schoolName: '',
    schoolCode: '',
    schoolYear: '',
    CMGradingScale: '',
    CNGradingScale: '',
    grade: [],
    finalGrade: '',
    credits: [],
    finalCredits: '',
    checkedNA: false,
    otherGradeScale: '',
    highestGrade: '',
    lowestGrade: '',
    subject: '',
    courseName: '',
    class: '',
    otherClass: '',
    schedule: '',
    otherSchedule: '',
    schedule_transcript: '',
    isFirstSemester: false,
    isSecondSemester: false,
    isThirdSemester: false,
    isFourthSemester: false,
    isTakeIn678Grade: false,
    isUsedBlockScheduling: false,
    classOccurredDuringTime: 'Regular academic year',
    classOccurredDuringGrade: props.defaultGradeValue ?? '9th or earlier',
    typeOfClass: '',
    isTakeClassAtCollege: false,
    collegeTookClass: '',
    subjectDetails: [],
    number_of_summer_courses: 0,
    have12thGradeCourses: '',
    allNoneAGCourses: false,
  };
  const formItem = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {
      let count = values.subjectDetails?.filter((i: any) => i.isSummerCourse).length;
      values.number_of_summer_courses = count;
    },
  });

  const buildGradingOptions = (scale: string, is12?: boolean) => {
    let result: any[] = [];
    switch (scale) {
      case 'A-F':
        result = AToFGrade;
        break;
      case '0-100':
      case '0-105':
        // Strings so Select value matches JSON-persisted grades (numbers used to "disappear" on reload)
        result = [
          ...optionStringValues(Array.from({ length: 106 }, (_, i) => i).reverse()),
          ...to100Grade,
        ];
        break;
      case '0-110':
        result = [
          ...optionStringValues(Array.from({ length: 111 }, (_, i) => i).reverse()),
          ...to100Grade,
        ];
        break;
      case '0.0-4.0':
        result = [
          ...optionStringValues(Array.from({ length: 41 }, (_, i) => i / 10).reverse()),
          ...to4Grade,
        ];
        break;
      case '0.0-5.0':
        result = [
          ...optionStringValues(Array.from({ length: 51 }, (_, i) => i / 10).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-7 (IB)':
        result = [
          ...optionStringValues(Array.from({ length: 7 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-10':
        result = [
          ...optionStringValues(Array.from({ length: 10 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-11':
        result = [
          ...optionStringValues(Array.from({ length: 11 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      case '1-20':
        result = [
          ...optionStringValues(Array.from({ length: 20 }, (_, i) => i + 1).reverse()),
          ...to4Grade,
        ];
        break;
      default:
        result = [];
    }
    if (is12) {
      result = [null, 'In Progress', 'Planned', ...result];
    }
    return result;
  };

  const initGradingOptions = () => {
    return buildGradingOptions(formItem.values.CMGradingScale, props.is12);
  };

  const [gradingOptions, setGradingOptions] = useState<any[]>([]);
  useEffect(() => {
    setGradingOptions(initGradingOptions());
  }, [formItem.values.CMGradingScale]);

  const [schoolError, setSchoolError] = useState<null | string>(null);
  // Generate Year Options
  const genYearOptions = (selectedSchool: any) => {
    if (selectedSchool.other) {
      const years = buildYears(selectedSchool);
      if (!!years) {
        const yearOptions = removeDuplicate(years).map((element: any) => {
          return {
            id: element.replaceAll(' ', ''),
            name: element.replaceAll(' ', '').replaceAll('-20', '-'),
          };
        });
        setYearOptions(yearOptions);
        setSchoolError(null);
      } else {
        setYearOptions([]);
        setSchoolError('Year not found, please select valid year in highschool section');
      }
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  /**
   * Resolve Education high school for this grade card.
   * Match by name first, then CEEB/code. If the card was delinked ('-' / empty)
   * and the student only has one high school, recover that school.
   */
  const resolveLinkedSchool = (item: any) => {
    const schoolsReady = Array.isArray(highSchoolData) && highSchoolData.length > 0;
    if (!schoolsReady) {
      return { schoolsReady: false, school: null as (typeof highSchoolData)[number] | null };
    }

    const rawName = item?.schoolName;
    const hasName = !!rawName && rawName !== '-';
    if (hasName) {
      const byName = highSchoolData.find((i) => i.id === rawName);
      if (byName) return { schoolsReady: true, school: byName };
    }

    const rawCode = item?.schoolCode;
    if (rawCode !== undefined && rawCode !== null && String(rawCode).trim() !== '') {
      const byCode = highSchoolData.find((i) => String(i.code) === String(rawCode));
      if (byCode) return { schoolsReady: true, school: byCode };
    }

    // Common counselor case: one school, grade card previously wiped to '-'
    if (!hasName && highSchoolData.length === 1) {
      return { schoolsReady: true, school: highSchoolData[0] };
    }

    return { schoolsReady: true, school: null };
  };

  const schoolSyncKeyRef = useRef<string>('');

  // Auth + college fetch once on mount
  useEffect(() => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      if (props.is12) {
        dispatch(getCollegeData(studentId));
      }
    } else {
      handleLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load / rematch school when grade item or Education school list is ready.
  // Important: do NOT clear schoolName to '-' while highSchoolData is still [].
  // That race was persisting delinked schools into grade_*_course_array.
  useEffect(() => {
    if (!props.item) return;

    const schoolsReady = Array.isArray(highSchoolData) && highSchoolData.length > 0;
    const schoolsKey = schoolsReady
      ? highSchoolData.map((i) => `${i.id}:${i.code}`).join('|')
      : 'pending';
    const syncKey = `${props.index}|${props.item?.schoolName ?? ''}|${props.item?.schoolCode ?? ''}|${schoolsKey}`;
    if (schoolSyncKeyRef.current === syncKey) return;

    // Don't clobber in-progress edits unless the form school is still delinked
    const formSchoolName = formItem.values.schoolName;
    const formLooksLinked = !!formSchoolName && formSchoolName !== '-';
    if (formItem.dirty && formLooksLinked) {
      schoolSyncKeyRef.current = syncKey;
      return;
    }

    schoolSyncKeyRef.current = syncKey;

    const { school: matchedSchool } = resolveLinkedSchool(props.item);
    const previousName = props.item?.schoolName;
    const previousCode = props.item?.schoolCode;
    const wasDelinked = !previousName || previousName === '-';

    let schoolName = previousName && previousName !== '-' ? previousName : '';
    let schoolCode = previousCode ?? '';

    if (matchedSchool) {
      schoolName = matchedSchool.id;
      schoolCode = matchedSchool.code ?? schoolCode;
    } else if (schoolsReady && wasDelinked) {
      // Schools loaded and still no match — leave empty (do not write '-')
      schoolName = '';
      schoolCode = '';
    }
    // If schools not ready yet: keep whatever was saved on the grade card.

    const loadedValues = {
      ...formItem.values,
      ...props.item,
      schoolName,
      schoolCode,
    };

    fixCourseSubjectDetail(loadedValues);
    normalizeCourseGradesToStrings(loadedValues);

    if (loadedValues.schedule === 'Yearly' || loadedValues.schedule === 'Other') {
      loadedValues.subjectDetails?.forEach((item: any) => {
        if (item) item.schedule_transcript = '';
      });
    }

    fixCourseConfigValues(loadedValues);

    // resetForm keeps dirty=false so we don't autosave a bad wipe
    formItem.resetForm({ values: loadedValues });

    if (matchedSchool) {
      genYearOptions(matchedSchool);
      setAddSubject(true);
    } else {
      setAddSubject(!!schoolName);
    }

    // Persist recovery so 9/10/11/12 stay linked after a prior delink
    const recovered =
      !!matchedSchool &&
      (wasDelinked ||
        previousName !== matchedSchool.id ||
        String(previousCode ?? '') !== String(matchedSchool.code ?? ''));
    if (recovered) {
      props.handleSave(loadedValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item, highSchoolData, props.index]);

  const handleChangeCourseUpdateToHighschool = (value: any) => {
    const highschoolList = checkEnableParseJSON(myHighSchool?.high_school_array, []);
    const index = highschoolList?.findIndex(
      (i: any) => i.high_school_name === value?.schoolName || i.fullName === value?.schoolName
    );
    if (
      value?.schoolName &&
      index >= 0 &&
      highschoolList[index]?.allNoneAGCourses !== value?.allNoneAGCourses
    ) {
      const newHighschools = [...highschoolList];
      newHighschools[index].allNoneAGCourses = value?.allNoneAGCourses;

      newHighschools.length &&
        dispatch(
          updateHighSchoolFromCourse({
            ...myHighSchool,
            high_school_array: JSON.stringify(newHighschools),
          })
        );
    }
  };



  // Debounced save function to prevent excessive API calls
  const debouncedSave = useCallback(
    debounce((values) => {
      props.handleSave(values);
    }, 1000),
    [props.handleSave]
  );

  // Cleanup debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedSave.cancel();
    };
  }, [debouncedSave]);

  /* bug: item do not saved
  // Additional useEffect to track changes in subjectDetails specifically
  useEffect(() => {
    if (formItem.values.subjectDetails) {
      // Check if there are any meaningful values in subjectDetails
      const hasSubjectData = formItem.values.subjectDetails.some((subject: any) => 
        subject && (subject.subject || subject.courseName || subject.grade || subject.credits)
      );
      
      // Check if the array has actually changed
      const currentArray = JSON.stringify(formItem.values.subjectDetails);
      const previousArray = JSON.stringify(previousSubjectDetailsRef.current);
      const hasChanged = currentArray !== previousArray;
      
      // Only save if there's actual data, form is dirty, and array has changed
      if (hasSubjectData && formItem.dirty && hasChanged) {
        let count = formItem.values.subjectDetails?.filter((i: any) => i && i.isSummerCourse).length;
        const newValues = {
          ...formItem.values,
          allNoneAGCourses: !(
            formItem.values.subjectDetails?.filter(
              (i: any) => i && i.AGSubjectArea !== 'Non A-G Course'
            )?.length > 0
          ),
        };
        newValues.number_of_summer_courses = count;
        handleChangeCourseUpdateToHighschool(newValues);
        fixCourseConfigValues(newValues);
        debouncedSave(newValues);
      }
      
      // Update the ref with current array
      previousSubjectDetailsRef.current = formItem.values.subjectDetails;
    }
  }, [formItem.values, debouncedSave, formItem.dirty]);
  */

  useEffect(() => {
    if (formItem.dirty) {
      let count = formItem.values.subjectDetails?.filter((i: any) => i && i.isSummerCourse).length;
      const newValues = {
        ...formItem.values,
        allNoneAGCourses: !(
          formItem.values.subjectDetails?.filter(
            (i: any) => i && i.AGSubjectArea !== 'Non A-G Course'
          )?.length > 0
        ),
      };
      newValues.number_of_summer_courses = count;
      normalizeCourseGradesToStrings(newValues);
      handleChangeCourseUpdateToHighschool(newValues);
      fixCourseConfigValues(newValues);
      props.handleSave(newValues);
    }
  }, [formItem.values]);


  // Track changes in main fields to ensure form is marked as dirty
  useEffect(() => {
    const hasMainFieldChanges = formItem.values.schoolName || 
                               formItem.values.schoolYear || 
                               formItem.values.schedule || 
                               formItem.values.CMGradingScale;
    
    if (hasMainFieldChanges) {
      // Mark form as dirty when main fields change
      formItem.setFieldTouched('schoolName', true);
    }
  }, [formItem.values.schoolName, formItem.values.schoolYear, formItem.values.schedule, formItem.values.CMGradingScale]);

  // Ensure form is marked as dirty when subjectDetails has meaningful data
  useEffect(() => {
    if (formItem.values.subjectDetails) {
      const hasMeaningfulData = formItem.values.subjectDetails.some((subject: any) => 
        subject && (subject.subject || subject.courseName || subject.grade || subject.credits)
      );
      
      if (hasMeaningfulData) {
        // Mark form as dirty when there's meaningful subject data
        formItem.setFieldTouched('subjectDetails', true);
      }
    }
  }, [formItem.values.subjectDetails]);

  const handleAddSubject = () => {
    if (formItem.values.subjectDetails.length > MAX_SUBJECTS - 1) {
      setAddSubject(false);
      return;
    }

    const newSubject = {
      ...subjectDetailModal,
      index: formItem.values.subjectDetails.length + 1,
      lastIndex: null,
      isNew: true,
    };

    const updatedSubjects = [...formItem.values.subjectDetails, newSubject];
    formItem.setFieldValue('subjectDetails', updatedSubjects);
  };

  const [forceRenderKey, setForceRenderKey] = useState(0);
  const previousSubjectDetailsRef = useRef<any[]>([]);

  // ModalConfirm state for subject removal
  const [openConfirm, setOpenConfirm] = useState(false);
  const [removeIndex, setRemoveIndex] = useState<number | null>(null);
  const handleClose = () => {
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  const handleConfirm = (index: number) => {
    const newData = [...formItem.values.subjectDetails];
    newData.splice(index, 1);
    formItem.setFieldValue('subjectDetails', newData);
    let count = newData?.filter((i: any) => i.isSummerCourse).length;
    formItem.setFieldValue('number_of_summer_courses', count);
    setOpenConfirm(false);
    setRemoveIndex(null);
  };

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    let lsData: any[] = [];
    if (formItem.values.subjectDetails && formItem.values.subjectDetails.length > 0) {
      lsData = formItem.values.subjectDetails.map((e: SubjectDetail, i: number) => {
        return { ...e, index: i + 1, lastIndex: i + 1 };
      });
    }

    const dataList = reorder(lsData, result.source.index, result.destination.index);
    if (dataList && dataList.length > 0) {
      for (let j = 0; j < dataList.length; j++) {
        dataList[j].index = j + 1;
      }
    }
    formItem.setFieldValue('subjectDetails', [...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };

  const [yearOptions, setYearOptions] = useState<{ id: string; name: string }[]>(schoolYearOptions);

  const [expandAllSubject, setExpandAllSubject] = useState(false);

  const handleExpandAll = () => {
    if (!check) {

      setExpandAllSubject(!expandAllSubject);
      // if (!expandAllSubject) {
      //   setExpandActive(courseData.length);
      // } else {
      //   setExpandActive(0);
      // }
    } else {
      setExpandAllSubject(!expandAllSubject);
    }
  };

  const onSelectSchool = (e: any) => {
    formItem.handleChange(e);
    formItem.setFieldValue(
      'schoolCode',
      highSchoolData.find((item) => item.id === e.target.value)?.code
    );
    let selectedSchool = highSchoolData.find((item) => item.id === e.target.value);
    if (!!selectedSchool) {
      genYearOptions(selectedSchool);
      setAddSubject(true);
    }
  };

  const [expanded, setExpanded] = React.useState(false);

  // Đồng bộ expanded với prop expandAll
  useEffect(() => {
    setExpanded(props.expandAll ?? false);
    props.onExpandChange?.(props.index - 1, props.expandAll ?? false);
  }, [props.expandAll]);

  const handleExpandClick = () => {
    setExpanded((prev) => {
      const next = !prev;
      props.onExpandChange?.(props.index - 1, next);
      return next;
    });
  };

  const buildHeader = () => {
    const schoolLabel = formItem.values.schoolName || 'New School';
    const schoolYearLabel =
      yearOptions.find(
        (y) => y.id === formItem.values.schoolYear || y.name === formItem.values.schoolYear,
      )?.name || formItem.values.schoolYear;
    const scheduleLabel =
      formItem.values.schedule === 'Other' && formItem.values.otherSchedule
        ? formItem.values.otherSchedule
        : formItem.values.schedule;
    const gradingScaleLabel = formItem.values.CMGradingScale;

    const headerChipSx = {
      borderRadius: '999px',
      borderColor: '#4D88F0',
      color: '#1E3A5F',
      backgroundColor: 'rgba(255,255,255,0.55)',
      fontWeight: 500,
      height: 24,
      '& .MuiChip-label': { px: 1.25, fontSize: 12, lineHeight: 1.2 },
    };

    return (
      <div className="d-flex justify-content-between align-items-center w-100 gap-2">
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: 8, minWidth: 0, flex: 1 }}
        >
          <span className="fw-bold" style={{ wordBreak: 'break-word' }}>
            {schoolLabel}
          </span>
          {schoolYearLabel && (
            <Chip label={schoolYearLabel} size="small" variant="outlined" sx={headerChipSx} />
          )}
          {scheduleLabel && (
            <Chip label={scheduleLabel} size="small" variant="outlined" sx={headerChipSx} />
          )}
          {gradingScaleLabel && (
            <Chip label={gradingScaleLabel} size="small" variant="outlined" sx={headerChipSx} />
          )}
        </div>
        <div className="d-flex align-items-center flex-shrink-0">
          <span className="text-muted me-2">
            {props.index}/{props.total}
          </span>
          <StyledExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </StyledExpandMore>
          {props.handleRemove && (
            <IconButton onClick={props.handleRemove} size="small">
              <RemoveCircleOutlineIcon />
            </IconButton>
          )}
        </div>
      </div>
    );
  };

  return (
    <Card 
      className="w-100 my-3 px-0 gm-course-card" 
      key={props.index}
    >
      <CardActions
        id={`courseItem${props.index}`}
        disableSpacing
        onClick={handleExpandClick}
        sx={{
          backgroundColor: expanded ? '#AAEBF7' : 'none',
          borderBottom: expanded ? '2px solid #4D88F0' : 'none',
          marginLeft: '-8px',
        }}
        style={{ cursor: 'pointer' }}
        className="px-4"
      >
        {buildHeader()}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className="gm-card-content" onClick={(e) => e.stopPropagation()}>
          <div className="px-3 gm-form-fields">
            <Grid container spacing={2}>
              <Grid xs={12}>
                <SelectInput
                  id={`schoolName_${props.index}`}
                  label="Select the school for this coursework *"
                  option={highSchoolData.map((i) => i.id)}
                  className="common-flag"
                  mdCol="12"
                  placeholder="Search your school"
                  name="schoolName"
                  values={formItem.values.schoolName}
                  onChange={onSelectSchool}
                  isMissing={!formItem.values.schoolName && check ? true : false}
                  disabled={props.disabled}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  id={`schoolYear_${props.index}`}
                  className="common-flag"
                  form={formItem}
                  option={yearOptions}
                  mdCol="12"
                  label="School Year*"
                  values={formItem.values.schoolYear}
                  name="schoolYear"
                  onChange={formItem.handleChange}
                  feedback={<span style={{ color: 'red' }}>{schoolError}</span>}
                  isMissing={!formItem.values.schoolYear && check ? true : false}
                  disabled={props.disabled}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  id={`schedule_${props.index}`}
                  mdCol="12"
                  form={formItem}
                  option={scheduleOptions}
                  label="Schedule*"
                  values={formItem.values.schedule}
                  name="schedule"
                  onChange={(e: any) => {
                    if (e.target.value === 'Yearly' || e.target.value === 'Other') {
                      formItem.values.subjectDetails.forEach((item: any, index: number) => {
                        formItem.setFieldValue(`subjectDetails[${index}].schedule_transcript`, '');
                      });
                    }
                    formItem.handleChange(e);
                  }}
                  isMissing={!formItem.values.schedule && check ? true : false}
                  disabled={props.disabled}
                />
              </Grid>

              {formItem.values.schedule === 'Other' && (
                <Grid xs={12} md={6}>
                  <TextInput
                    id={`otherSchedule${props.index}`}
                    countText={30}
                    mdCol="12"
                    label="Please describe schedule*"
                    values={formItem.values.otherSchedule}
                    name="otherSchedule"
                    onChange={formItem.handleChange}
                    isMissing={!formItem.values.otherSchedule && check ? true : false}
                    disabled={props.disabled}
                  />
                </Grid>
              )}

              <Grid xs={12} md={6}>
                <SelectInput
                  className="common-flag end-flag"
                  mdCol="12"
                  form={formItem}
                  option={gradingScaleOptions}
                  label="Grading Scale"
                  id={`CMGradingScale_${props.index}`}
                  values={formItem.values.CMGradingScale}
                  name="CMGradingScale"
                  onChange={(e: any) => {
                    try {
                      const newScale = e.target.value;
                      formItem.setFieldValue(`CMGradingScale`, newScale);
                      const nextOptions = buildGradingOptions(newScale, props.is12);
                      setGradingOptions(nextOptions);
                      const allowed = gradingOptionKeys(nextOptions);

                      formItem.values.subjectDetails.forEach((item: any, index: number) => {
                        try {
                          // Only clear grades that are invalid under the NEW scale
                          // (old bug: grade.includes(gradingOptions) was always false → wiped all)
                          const grade: any[] = item.grade;
                          if (grade && grade.length > 0) {
                            for (let k = 0; k < grade.length; k++) {
                              const g = grade[k];
                              if (g === '' || g === undefined) continue;
                              const key = g === null ? null : String(g);
                              if (!allowed.has(key)) {
                                formItem.setFieldValue(`subjectDetails[${index}].grade[${k}]`, '');
                              }
                            }
                          }

                          const finalGrade = formItem.values.subjectDetails[index]?.finalGrade;
                          if (
                            formItem.values.subjectDetails[index]?.schedule_transcript !==
                              'One grade per term' &&
                            finalGrade !== '' &&
                            finalGrade !== undefined
                          ) {
                            const finalKey = finalGrade === null ? null : String(finalGrade);
                            if (!allowed.has(finalKey)) {
                              formItem.setFieldValue(`subjectDetails[${index}].finalGrade`, '');
                            }
                          }
                        } catch (ex2) {
                          console.log('Error:', ex2);
                        }
                      });
                    } catch (ex) {
                      console.log('Error:', ex);
                    }
                  }}
                  disabled={props.disabled}
                />
              </Grid>
            </Grid>

            {formItem.values.subjectDetails.length > 0 && (
              <div className="d-flex justify-content-end mt-3"  style={{ paddingRight: '15px' }}>
                <ActivitiesExpandMore
                  aria-expanded={expandAllSubject}
                  aria-label="show all"
                  onClick={handleExpandAll}
                >
                  {!expandAllSubject ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
                </ActivitiesExpandMore>
              </div>
            )}

            <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
              <Droppable droppableId="list">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {formItem.values.subjectDetails.map((item, index) => (
                      <div key={index + '-' + formItem.values.subjectDetails.length}>
                        <Draggable
                          draggableId={index + '-' + formItem.values.subjectDetails.length}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <div
                                key={index + '-' + formItem.values.subjectDetails.length}
                                className="position-relative"
                                style={{ paddingRight: '15px' }}
                              >
                                <SubjectConfig
                                  courseIndex={props.index}
                                  form={formItem}
                                  item={item}
                                  index={index}
                                  total={formItem.values.subjectDetails.length}
                                  is12={props.is12}
                                  gradingOptions={gradingOptions}
                                  expandAll={expandAllSubject}
                                  disabled={props.disabled}
                                />
                                <RemoveCircleOutlineIcon
                                  className="position-absolute text-field-light pointer"
                                  style={{ right: '-10px', top: '16px', opacity: props.disabled ? 0.5 : 1, cursor: props.disabled ? 'not-allowed' : 'pointer' }}
                                  onClick={() => {
                                    if (props.disabled) return;
                                    setRemoveIndex(index);
                                    setOpenConfirm(true);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </Draggable>
                      </div>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            {addSubject && (
            <div className="gm-add-subject-section mt-3">
              <div className="gm-add-subject-info">
                <span className="gm-add-subject-text">{`You can add up to ${MAX_SUBJECTS} subjects`}</span>
              </div>
              <Button variant="primary" className="p-2 px-5" onClick={handleAddSubject}>
                Add Subject
              </Button>
            </div>
            )}
            
          </div>
        </CardContent>
      </Collapse>
      <ModalConfirm 
        open={openConfirm}
        handleClose={handleClose} 
        handleConfirm={() => {
          if (removeIndex !== null) handleConfirm(removeIndex);
        }}
        title=""
        message="Are you sure you want to remove this course?"
        confirmText="Remove"
        cancelText="Cancel"
      />
      <style scoped>{`
        .gm-course-card {
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .gm-card-header {
          padding: 16px;
          border-bottom: 1px solid #e0e0e0;
        }
        .gm-card-content {
          padding: 24px 0;
        }
        .gm-form-fields {
          max-width: 100%;
        }
        .gm-add-subject-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
        .gm-add-subject-info {
          margin-bottom: 16px;
        }
        .gm-add-subject-text {
          color: #666;
          font-size: 0.875rem;
        }
      `}</style>
    </Card>
  );
};

export const resetIndexGradecourse = (gradeCourses: any[]) => {
  if (gradeCourses && gradeCourses.length > 0) {
    for (let i = 0; i < gradeCourses.length; i++) {
      gradeCourses[i].index = i + 1;
      gradeCourses[i].lastIndex = null;
      let subjectDetails: any[] = gradeCourses[i].subjectDetails;
      if (subjectDetails && subjectDetails.length > 0) {
        for (let j = 0; j < subjectDetails.length; j++) {
          if (subjectDetails[j]) {
            subjectDetails[j].index = j + 1;
            subjectDetails[j].lastIndex = null;
          }
        }
      }
    }
  }
};

export const hasReOrderGradecourse = (gradeCourses: any[]) => {
  if (gradeCourses && gradeCourses.length > 0) {
    for (let i = 0; i < gradeCourses.length; i++) {
      if (gradeCourses[i].lastIndex != null) {
        return true;
      }
      let subjectDetails: any[] = gradeCourses[i].subjectDetails;
      if (subjectDetails && subjectDetails.length > 0) {
        for (let j = 0; j < subjectDetails.length; j++) {
          if (subjectDetails[j]?.lastIndex != null) {
            return true;
          }
        }
      }
    }
  }
  return false;
};

export default CourseConfig;
